import { createFileRoute } from '@tanstack/react-router'
import EditionBinding from 'Edition/components/sections/Layout/EditionBinding'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout-binding')({
    component: EditionBinding,
})
